import { animate, utils } from 'animejs';

export default class EplibAnimationUtils {

  static _animatePageNav(direction, easingDirection, root, contentSelector, loadingSelector) {
    const content = root.querySelector(contentSelector);
    if (content) {
      const translation = direction === 'nav-next'
                        ? easingDirection === 'out' ? ['0%', '-100%'] : ['100%', '0%']
                        : easingDirection === 'out' ? ['0%', '100%'] : ['-100%', '0%'];
      return animate(content,
      {
        opacity: easingDirection === 'out' ? [1, 0] : [0, 1],
        duration: easingDirection === 'out' ? 600 : 400,
        translateX: translation,
        ease: easingDirection === 'out' ? 'OutCubic' : 'InCubic',
        onBegin: () => {
          this._stopLoadingAnimation(root, loadingSelector);
          const container = root.host.parentElement;
          if (container) {
            container.style.overflowX = 'hidden';
          }
        },
        onComplete: () => {
          easingDirection === 'out'
            ? this._startLoadingAnimation(direction, root, loadingSelector)
            :  this._stopLoadingAnimation(root, loadingSelector);
        }
      });
    }
    return null;
  }

  static _startLoadingAnimation(direction, root, selector) {
    const loadingBar = root.querySelector(selector);
    if (loadingBar) {
      if (root.host) {
        root.host.loading = true;
      }
      const container = root.host.parentElement;
      if (container) {
        container.style.overflowX = 'hidden';
      }
      animate(loadingBar,
      {
        translateX: direction === 'nav-next' ?  ['50%', '-50%'] : ['-50%', '50%'],
        duration: 850,
        easing: 'outInSine',
        opacity: [1, 0.25],
        loop: true
      });
    }
  }

  static _stopLoadingAnimation(root, selector) {
    const loadingBar = root.querySelector(selector);
    if (loadingBar) {
      if (root.host) {
        root.host.loading = false;
      }
      utils.remove(loadingBar);
    }
    const container = root.host.parentElement;
    if (container) {
      container.style.overflowX = 'auto';
    }
  }

}